
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedirectEntity"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redirectType"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCacheControlFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryCacheControlFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CmsPage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmsPageFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmsPageCacheControlFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrismicPage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrismicPageFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlogPost"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlogPostFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1011}};
    doc.loc.source = {"body":"#import \"theme/pages/Product/ProductFragment.gql\"\n#import \"theme/pages/Category/CategoryFragment.gql\"\n#import \"theme/pages/CmsPage/CmsPageFragment.gql\"\n#import \"theme/pages/Product/ProductCacheControlFragment.gql\"\n#import \"theme/pages/Category/CategoryCacheControlFragment.gql\"\n#import \"theme/pages/CmsPage/CmsPageCacheControlFragment.gql\"\n#import \"theme/pages/PrismicPage/PrismicPageFragment.gql\"\n#import \"theme/pages/Blog/Post/BlogPostFragment.gql\"\n\nquery MatchUrls($url: String!, $params: QueryInput) {\n  route(url: $url) {\n    path\n    __typename\n    ... on RedirectEntity {\n      redirectTo\n      redirectType\n    }\n    ... on Product {\n      ...ProductFragment\n      ...ProductCacheControlFragment\n    }\n    ... on Category {\n      ...CategoryFragment\n      ...CategoryCacheControlFragment\n    }\n    ... on CmsPage {\n      ...CmsPageFragment\n      ...CmsPageCacheControlFragment\n    }\n    ... on PrismicPage {\n      ...PrismicPageFragment\n    }\n    ... on BlogPost {\n      ...BlogPostFragment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("theme/pages/Product/ProductFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/Category/CategoryFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/CmsPage/CmsPageFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/Product/ProductCacheControlFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/Category/CategoryCacheControlFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/CmsPage/CmsPageCacheControlFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/PrismicPage/PrismicPageFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("theme/pages/Blog/Post/BlogPostFragment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MatchUrls"] = oneQuery(doc, "MatchUrls");
        
